export default __webpack_public_path__ + "static/watch-on-lean-web-teal-c9926dcdb1566aa73c1f47e3d620adfc.png";